import { Component } from "@angular/core";

@Component({
    selector: "vds-dialog-actions",
    template: "<ng-content />",
    host: { class: "vds-dialog-actions" }
})
export class VdsDialogActionsComponent {}
